import {FC, memo} from "react";
import styled from "styled-components";

import camera from "../../image/camera.png"

import { CameraVideoFill } from "react-bootstrap-icons";
import {useNavigate} from "react-router-dom";

export type NavButtonContainerProps = {
    focus: boolean;
};

const NavButtonContainer = styled.div<NavButtonContainerProps>`
  display: flex;
  justify-content: center;
  justify-items: center;
  padding: 10px;
  gap: 5px;
  
  //border-bottom: 2px solid transparent;

  border-bottom: ${({focus}) =>  focus == true ? "2px solid blue" : "2px solid transparent"};
  
  transition: .3s border;
  
  &:hover {
    border-bottom: 2px solid blue;
  }

  &:focus {
    border-bottom: 2px solid blue;
  }

  &:focus-visible {
    border-bottom: 2px solid blue;
  }

`

const NavButtonIcon = styled.img`
  //object-fit: inherit;
  max-width: 50px;
  max-height: 50px;
  //background: inherit;
  
`
const NavButtonText= styled.p`
    margin: 0;
  align-self: center;
`


export interface INavButton {
    image: string,
    name: string
    link: string,
    focus: boolean,
}

const NavButton: FC<INavButton> = (props) => {
    const nav = useNavigate();
    const {name, image, link, focus} = props

    const handleClick = () => {
        nav(link);
    }

    return (
        <NavButtonContainer onClick={handleClick} focus={focus}>
            <NavButtonIcon src={image}/>
            <NavButtonText>{name}</NavButtonText>
        </NavButtonContainer>
    )
}

export default memo(NavButton)
